import type { ReactNode } from 'react';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { RoutesProvider } from 'components/common/RoutesProvider';
import NotifierProvider from 'providers/NotifierProvider';
import store, { persistor } from 'store';

import { RemoteSettingsProvider } from './RemoteSettingsProvider';
import VejetpackProvider from './VejetpackProvider';
import INTLProvider from './INTLProvider';

interface ProvidersProps {
  children: ReactNode;
}

const Providers = ({ children }: ProvidersProps) => (
  <RoutesProvider>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <INTLProvider>
          <RemoteSettingsProvider>
            <VejetpackProvider>
              <NotifierProvider>{children}</NotifierProvider>
            </VejetpackProvider>
          </RemoteSettingsProvider>
        </INTLProvider>
      </PersistGate>
    </Provider>
  </RoutesProvider>
);

export default Providers;
